module.exports = __webpack_public_path__ + "img/cloud-mini.d8be763d.png";